/** Froala Pro License Key */

export const froalaKey =
  'WE1B5dD3G4A2A6B10D6cWHNGGDTCWHIg1Ee1Oc2Yc1b1Lg1POkB6B5F5C4F3D3I3F2A5C4==';
